module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.event.title + ' - Eventos',
      "back-route": "event.index"
    }
  }), _vm._v(" "), (_vm.list.length === 0) ? _c('list-empty', {
    attrs: {
      "description": "Nenhum evento encontrado"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Inscrições")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', {
      class: {
        '-no-access': !_vm.userHaveAccess(item.coordinators)
      }
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_c('div', [_vm._v("De: " + _vm._s(_vm._f("dateTimeEnToBr")(item.start_registration_datetime)))]), _vm._v(" "), _c('div', [_vm._v("Até: " + _vm._s(_vm._f("dateTimeEnToBr")(item.end_registration_datetime)))])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('router-link', {
      staticClass: "el-button el-button--primary",
      attrs: {
        "to": {
          name: 'event.show.home',
          params: {
            eventMainId: _vm.event.id,
            id: item.id
          }
        },
        "title": "Gerenciar"
      }
    }, [_c('span', [_vm._v("Gerenciar")]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-cog"
    })])], 1)])
  }))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.chartLineOptionsRegistrations) ? _c('div', [_c('highcharts', {
    key: 'registrations',
    attrs: {
      "options": _vm.chartLineOptionsRegistrations
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', [_c('highcharts', {
    key: 'papers',
    attrs: {
      "options": _vm.chartLineOptionsPapers
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('router-link', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "to": {
        name: 'event.presence',
        params: {
          id: _vm.event.id
        }
      },
      "title": "Frequência"
    }
  }, [_c('span', [_vm._v("Gerenciar Frequência")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-circle-check-outline"
  })]), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
    staticClass: "el-button el-button--info",
    attrs: {
      "to": {
        name: 'event.report',
        params: {
          id: _vm.event.id
        }
      },
      "title": "Relatórios"
    }
  }, [_c('span', [_vm._v("Relatórios")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })]) : _vm._e(), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
    staticClass: "el-button el-button--warning",
    attrs: {
      "to": {
        name: 'event.report-admin',
        params: {
          id: _vm.event.id
        }
      },
      "title": "Relatórios"
    }
  }, [_c('span', [_vm._v("Relatórios Gerenciais")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })]) : _vm._e(), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
    staticClass: "el-button el-button--danger",
    attrs: {
      "to": {
        name: 'event.report-finals',
        params: {
          id: _vm.event.id
        }
      },
      "title": "Relatórios"
    }
  }, [_c('span', [_vm._v("Relatórios Finais")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })]) : _vm._e(), _vm._v(" "), (!_vm.userIsOnlySupportCommittee) ? _c('router-link', {
    staticClass: "el-button el-button--info",
    attrs: {
      "to": {
        name: 'event.report-minicursos',
        params: {
          id: _vm.event.id
        }
      },
      "title": "Relatórios"
    }
  }, [_c('span', [_vm._v("Relatórios Minicursos")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f35cef0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/ListEvents.vue
// module id = 716
// module chunks = 2